module.exports = __webpack_public_path__ + "img/step5.5b.61682a43.png";